export default function useCountryId() {
  return global.__AT_DATA__.countryId;
}
